import React, { useState, useEffect ,useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import { Listitems , Deleteitems} from '../store/slices/items';
import Loader from '../common/Loader';
import { useDispatch, useSelector } from 'react-redux';
import Table from '../common/Table';
import AdminLayout from './AdminLayout';
import {toast } from 'react-hot-toast';

const Item = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableRef=useRef(null)

  const user = JSON.parse(localStorage.getItem('user'));
  const id = user?.data?.profile_id;

  const [isLoading, setIsLoading] = useState(false);
  const [itemList, setItemList] = useState([]);
  const [columns, setcolumns] = useState([
    { header: 'Category', field: 'category_name' },
    { header: 'Item Name', field: 'name' },
    { header: 'Sale Price', field: 'sale_price' },
    { header: 'Purchase Price', field: 'purchase_price' },
    { 
      header: 'Actions', 
      field: 'actions', 
      isAction: true, 
      actionButtons: [
        { name: 'Edit', className: 'btn-default' }, 
        { name: 'Delete', className: 'btn-cancel' },
        { name: 'View Item Ledger', className: 'btn-default' }, 
      ]
    }
  ]);
 

  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleEdit = (item) => {
      navigate(`/edit-item/${item.id ? item.id : null}`)
      // Implement your edit logic here
  };
  const handleLedger = (item) => {
    navigate(`/item-ledger-list/${item.id ? item.id : null}`)
    // Implement your edit logic here
};

  const handleDelete = (item) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this Items?");
      if (confirmDelete) {
            setIsLoading(true);
            dispatch(Deleteitems({ id: item.id ,profile_id:id}))
            .unwrap()
            .then((data) => {
                setIsLoading(false);
                
                hindleReturn();
            })
            .catch(({ message }) => {
              setIsLoading(false);
              console.log(message);
              toast.error(message)
            });
      } else {
        console.log("Deletion canceled");
      }
  };

  const hindleReturn = () => {
    setIsLoading(true);
    dispatch(Listitems({ profile_id: id }))
      .unwrap()
      .then((data) => {
        setIsLoading(false);
        setItemList(data?.data);
      })
      .catch(({ message }) => {
        setIsLoading(false);
        console.log(message);
      });
  };



  React.useEffect(() => {
    setIsLoading(true);
    dispatch(Listitems({ profile_id: id }))
      .unwrap()
      .then((data) => {
        setIsLoading(false);
        setItemList(data?.data);

      })
      .catch(({ message }) => {
        setIsLoading(false);
        console.log(message);
      });
  }, [dispatch]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filtereditemList = itemList?.filter(party => 
    party?.type?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    party?.category_name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    party?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    party?.sale_price?.toLowerCase()?.includes(searchQuery?.toLowerCase())||
    party?.purchase_price?.toLowerCase()?.includes(searchQuery?.toLowerCase())

  );


  return (
    <AdminLayout>
        {isLoading && <Loader />}
          <div className="row content-body">
            <div className="container-fluid">
              <div className="page-header">
                <div>
                  <h2 className="main-content-title tx-24 mg-b-5">Items</h2>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="#">Items</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Items List
                    </li>
                  </ol>
                </div>
                <div className="d-flex justify-content-end">
                  <button className="btn ripple btn-default" onClick={() => navigate('/add-item')}>
                    Add Item
                  </button>
                  <button className="btn ripple btn-default" onClick={() => navigate('/reports/stocksummary')}>
                  Stock Summary
                  </button>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                 
                 <Table
                    columns={columns}
                    data={filtereditemList}
                    tableRef={tableRef}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    currentPage={currentPage}
                    totalCount={filtereditemList?.length}
                    onPageChange={handlePageChange}
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                    handleSearchChange={handleSearchChange}
                    handleLedger ={handleLedger}
                  />
                </div>
              </div>
            </div>
          </div>
        </AdminLayout>
  );
};

export default Item;
